import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./add-new-recipient.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./add-new-recipient.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import * as RecipientFormConstants from "../../recipient-select.constants";
import { SharedConstants } from "../../../../constants/shared.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertType } from "../../../../models/alert";
import { AppControllerService } from "../../../../../app-controller.service";
import { RecipientSelectService } from "../service/recipient-select.service";
import { AppConfig } from "src/app/app.config";
let AddNewRecipientComponent = class AddNewRecipientComponent {
    activeModal;
    changeDetectorRef;
    formBuilder;
    appController;
    recipientSelectService;
    title;
    groupsFromMetaData;
    showRecipientsGroupsDropdown = true;
    jobId;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    addNewRecipientForm;
    groups = RecipientFormConstants.GROUPS_FORM_CONTROL;
    streetAddress = RecipientFormConstants.ADDRESS_FORM_CONTROL;
    streetSuburb = RecipientFormConstants.SUBURB_FORM_CONTROL;
    streetCity = RecipientFormConstants.CITY_FORM_CONTROL;
    streetProvince = RecipientFormConstants.PROVINCE_FORM_CONTROL;
    streetCountry = RecipientFormConstants.COUNTRY_FORM_CONTROL;
    streetCode = RecipientFormConstants.CODE_FORM_CONTROL;
    postalAddress = RecipientFormConstants.POSTAL_ADDRESS_FORM_CONTROL;
    postalSuburb = RecipientFormConstants.POSTAL_SUBURB_FORM_CONTROL;
    postalCity = RecipientFormConstants.POSTAL_CITY_FORM_CONTROL;
    postalProvince = RecipientFormConstants.POSTAL_PROVINCE_FORM_CONTROL;
    postalCountry = RecipientFormConstants.POSTAL_COUNTRY_FORM_CONTROL;
    postalCode = RecipientFormConstants.POSTAL_CODE_FORM_CONTROL;
    validationMessage = RecipientFormConstants.validationMessage;
    dialogTitle;
    cancelBtnPlaceholder = SharedConstants.CANCEL_LABEL;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    defaultAddRecipientRecipient = RecipientFormConstants.ADD_DEFAULT_RECIPIENT_LABEL;
    // private readonly moduleId;
    constructor(activeModal, changeDetectorRef, formBuilder, appController, recipientSelectService) {
        this.activeModal = activeModal;
        this.changeDetectorRef = changeDetectorRef;
        this.formBuilder = formBuilder;
        this.appController = appController;
        this.recipientSelectService = recipientSelectService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.addNewRecipientForm = new FormGroup({
            recipientFormControl: new FormControl(null, Validators.required)
        });
        this.setConfigurableDialogTitle();
    }
    onBtnCancelClicked() {
        this.activeModal.close();
    }
    onBtnSaveClicked() {
        const newRecipientValue = this.addNewRecipientForm.get("recipientFormControl").value;
        if (this.addNewRecipientForm.valid && newRecipientValue.groups !== null) {
            const newRecipient = this.addNewRecipientForm.get("recipientFormControl").value;
            newRecipient.id = 0;
            newRecipient.moduleId = +this.appController.selectedModuleID;
            newRecipient.jobId = this.jobId ? +this.jobId : null;
            delete newRecipient.groupsStringArray;
            this.activeModal.close(newRecipient);
        }
        else {
            this.recipientSelectService.markFormControlAsTouched.emit(true);
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    setConfigurableDialogTitle() {
        if (this.title !== undefined) {
            this.dialogTitle = `Add ${this.title}`[0].toUpperCase() + `Add ${this.title}`.substr(1).toLowerCase();
        }
        else {
            this.dialogTitle = this.defaultAddRecipientRecipient;
        }
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: ChangeDetectorRef },
        { type: FormBuilder },
        { type: AppControllerService },
        { type: RecipientSelectService }
    ];
    static propDecorators = {
        title: [{ type: Input }],
        groupsFromMetaData: [{ type: Input }],
        showRecipientsGroupsDropdown: [{ type: Input }],
        jobId: [{ type: Input }]
    };
};
AddNewRecipientComponent = __decorate([
    Component({
        selector: "app-add-new-recipient",
        template: __NG_CLI_RESOURCE__0,
        encapsulation: ViewEncapsulation.None,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], AddNewRecipientComponent);
export { AddNewRecipientComponent };
